import { useAuthContext } from '../AuthProvider';
import { pickOrgMembership } from './pickOrgMembership';
import { useOrganizationContext } from './OrganizationProvider';

import type { UiOrganizationUser } from '../../schemas/organizationUser/organization.user.schema';

/**
 * "What am I in THIS organization" — the org-scoped answer that
 * `currentUser.type` only looks like. That field is filled by `GET /auth/me`,
 * which carries no `:organizationId`, so the backend takes the first of the
 * account's membership rows across ALL of its organizations, in no defined
 * order. Every gate that read it therefore described the account by a role it
 * may hold somewhere else entirely — showing owner-only affordances to a
 * client, and hiding them from the actual owner.
 *
 * Pass the organization a page is mounted on (`:organizationId`); omit it to
 * ask about the one currently selected in the switcher.
 */
export const useOrgMembership = (
  organizationId?: null | string,
): undefined | UiOrganizationUser => {
  const { currentUser } = useAuthContext();
  const { currentOrganization } = useOrganizationContext();
  return pickOrgMembership(
    currentUser?.organizationUsers,
    organizationId ?? currentOrganization?.id,
  );
};
